import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { GooglePlacesDirective } from './google-places.directive';
import { ThousandsFormatDirective } from './thousands-format.directive';
import { DatePickerComponent } from './date-picker/date-picker.component';

@NgModule({
  declarations: [GooglePlacesDirective, ThousandsFormatDirective, DatePickerComponent],
  imports: [CommonModule, FormsModule],
  exports: [GooglePlacesDirective, ThousandsFormatDirective, DatePickerComponent]
})
export class SharedModule {}
